import { Form, Input } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import { getFormInput } from '@source/constants/forms';
import { TRegionKey } from '@source/interface';
import { useTranslation } from 'react-i18next';
import { Button } from '@design-system/components';
import FormItems from '../FormItems/FormItems';

interface NotifyMeFormProps {
  countryCode?: TRegionKey;
  onFinish: (values: unknown) => void;
}

const StyledForm = styled(Form)`
  width: 311px !important;

  @media screen and (min-width: 768px) {
    width: 562px !important;
  }

  .ant-form-item-label {
    margin-bottom: 8px;
  }

  .ant-form-item-explain-error {
    margin-bottom: 16px;
  }

  .submit-btn {
    margin-bottom: 0;
  }
`;

const StyledSubmitButton = styled(Button)`
  width: 100%;
`;

const NotifyMeForm: FC<NotifyMeFormProps> = ({ countryCode, onFinish }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const { phone } = getFormInput(countryCode || 'sg', t);

  return (
    <StyledForm form={form} onFinish={onFinish} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
      <FormItems form={form} formItems={[{ ...phone, formItemStyle: { marginBottom: 24 } }]} />
      <Form.Item className="submit-btn" label={null}>
        <StyledSubmitButton type="primary" htmlType="submit">
          {t('shared.notifyMe.modal.submitBtnLabel')}
        </StyledSubmitButton>
      </Form.Item>
    </StyledForm>
  );
};

export default NotifyMeForm;
